<template>
  <div class="activationBonusList">
    <div>
      <el-form :inline="true">
        <el-form-item>
          <el-select v-model="form.agent" placeholder="请选择代理">
            <el-option
              v-for="item in form.agentData"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="form.startTime"
            type="datetime"
            placeholder="开始时间"
          ></el-date-picker>&nbsp;至&nbsp;
          <el-date-picker
            v-model="form.endTime"
            type="datetime"
            placeholder="结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small">{{$t('common.reset')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.search')}}</el-button>
          <el-button type="primary" size="small">{{$t('common.export')}}</el-button>
          <el-button type="primary" size="small">审批发放奖励</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column :prop="item.id" :label="item.name" v-for="item in tableNav"></el-table-column>
        <el-table-column :label="$t('common.handle')">
          <template slot-scope="scope">
            <el-button size="mini" type="primary">{{$t('common.edit')}}</el-button>
            <el-button size="mini" type="primary">审批</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="flexEnd" v-if="totalNum>0">
        <el-pagination
          background
          small
          @current-change="changeCurrentActivationBonusList"
          :current-page="currentPage"
          :page-size="pageSize"
          :pager-count="10"
          layout="total, prev, pager, next, jumper"
          :total="totalNum">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import Util from '@/utils/IM/tradeDataUtil'
  import nationalMarketing from '@/api/nationalMarketing/nationalMarketing'

  export default {
    name: 'activationBonusList',
    data() {
      return {
        form: {
          agent: '',
          agentData: [],
          startTime: new Date(),
          endTime: new Date()
        },
        tableNav: [
          { name: '结算账号', id: 'assignAccount' },
          { name: '交易账号', id: 'account' },
          { name: '交易平台', id: 'tradePlatform' },
          { name: '奖励类型', id: 'assignTypes' },
          { name: '直接推荐人', id: 'directAccount' },
          { name: '间接推荐人', id: 'indirectAccount' },
          { name: '奖励金额', id: 'assignAmount' },
          { name: '实际发放奖励金额', id: 'actualAssignAmount' },
          { name: '结算时间', id: 'auditTime' },
          { name: '发放状态', id: 'auditStatuss' }
        ],
        tableData: [],
        totalNum: 0,  //当前资源条数
        currentPage: 1,  //当前页数
        pageSize: 10 //当前页条数数
      }
    },
    methods: {
      getActivationBonusListData(data) {
        nationalMarketing.queryActiveIncomeListPage(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              let data = res.result.list
              for (const i in data) {
                if (Util.isNotEmpty(data[i].auditTime)) {
                  data[i].auditTime = new Date(data[i].auditTime).format('Y-MM-dd hh:mm:ss')
                }
                if (Util.isNotEmpty(data[i].assignType)) {
                  if (data[i].assignType == 0) data[i].assignTypes = '直接'
                  if (data[i].assignType == 1) data[i].assignTypes = '间接'
                }
                if (Util.isNotEmpty(data[i].auditStatus)) {
                  if (data[i].auditStatus == 0) data[i].auditStatuss = '待审批'
                  if (data[i].auditStatus == 1) data[i].auditStatuss = '审批通过'
                  if (data[i].auditStatus == 2) data[i].auditStatuss = '审批不通过'
                }
              }
              this.tableData = data
              this.totalNum = res.result.total
            }
          } else {
            this.$message.error(res.message)
          }
        })
      },
      initActivationBonusListData() {
        let data = {
          pageNum: this.currentPage
        }
        this.getActivationBonusListData(data)
      },
      changeCurrentActivationBonusList(val) {
        this.currentPage = val
        let data = {
          pageNum: val
        }
        this.getActivationBonusListData(data)
      }
    },
    mounted() {
      this.initActivationBonusListData()
    }
  }
</script>

<style lang="scss" scoped>
  .activationBonusList {
    margin: 20px;

    .flexEnd {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      margin-top: 20px;
    }
  }
</style>
